export { default } from './Variant';
